import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import Notifications from "vue-notification";
import VueGtm from "vue-gtm";
import VueMeta from "vue-meta";
import "font-awesome/css/font-awesome.min.css";
import "simple-line-icons/css/simple-line-icons.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import App from "./App";
import router from "./router";
import store from "@/store";
import filters from "@/filters";
import "@/assets/scss/style.scss";

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM, // Your GTM ID
  queryParams: {
    // Add url query string when load gtm.js with GTM ID (optional)
    gtm_auth: process.env.VUE_APP_GTM_AUTH,
    gtm_preview: process.env.VUE_APP_GTM_ENV
  },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.VUE_APP_GTM_DEBUG === "true", // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
});
Vue.use(VueMeta);

// Components
const globals = require.context("@/components/global", false, /.*\.vue$/);
globals.keys().forEach(fileName => {
  const config = globals(fileName);

  const name = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");

  Vue.component(name, config.default || config);
});

Vue.config.errorHandler = function(err, vm, info) {
  console.log(err, vm, info);
};

// global clipboard copy
Vue.prototype.$copy = navigator.clipboard.writeText.bind(navigator.clipboard);

// Filters
for (var filter in filters) {
  if (filters.hasOwnProperty(filter)) {
    Vue.filter(filter, filters[filter]);
  }
}

// Debugging
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  Vue.prototype.$log = console.log;
}

// Create init function to use after session check
/* eslint-disable no-new */
const init = () =>
  new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: {
      App
    }
  });

// Get user session before initializing Vue
Promise.all([
  store.dispatch("user/restoreSession"),
  store.dispatch("getProducts")
])
  .then(init)
  .catch(err => {
    // TODO: Logout on errors?
    // store.dispatch("logout");
    console.warn(err);
    init();
  });
